var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1977",
    transform: "translate(-2 -292.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1963",
    d: "M2.65,295.65a.652.652,0,0,0,0,1.3H3.3v7.17a2.612,2.612,0,0,0,2.6,2.607h5.2a2.612,2.612,0,0,0,2.6-2.607v-7.17h.65a.652.652,0,0,0,0-1.3Zm1.95,1.3h7.8v7.17a1.285,1.285,0,0,1-1.3,1.3H5.9a1.285,1.285,0,0,1-1.3-1.3Z",
    transform: "translate(0 -1.08)",
    fill: "#ff7979"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1972",
    d: "M9.64,292.65a.64.64,0,0,0,0,1.28H12.2a.64.64,0,0,0,0-1.28Z",
    transform: "translate(-2.42)",
    fill: "#ff7979"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.85a45b963191a380fa457a7f5de63425.svg";
export { ForwardRef as ReactComponent };